import React from "react";
import Loader from "../../../../Common/Loader";
import { useAuthenticateIntegration } from "../hooks/useAuthenticateIntegration";

export function ConstantContactIntegrationReturnUrl() {
  useAuthenticateIntegration({
    onSuccess: () => window.close(),
  });

  return (
    <div id="content">
      <Loader showLoader />
    </div>
  );
}
